import { MAIN_NET_ID } from "@liveart/nft-client/dist/chainId";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function queryNetworkByApiVersion(apiVersion: "v1" | "v2") {
    return MAIN_NET_ID;
}
